import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { images } from '../data/images';

const Industries = () => {
  const { t } = useLanguage();

  const industryImages = [
    images.industries.municipal,
    images.industries.manufacturing,
    images.industries.logistics,
    images.industries.airport,
    images.industries.library,
    images.industries.healthcare,
    images.industries.smartParking,
    images.industries.realEstate
  ];

  return (
    <section id="industries" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.industries.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.industries.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.industries.items.map((industry, index) => (
            <Card
              key={index}
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-200 overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src={industryImages[index]}
                  alt={industry.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/70 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg">{industry.title}</h3>
                </div>
              </div>

              <CardContent className="pt-4">
                <p className="text-gray-600 text-sm">{industry.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;